import WorkHistory from './WorkHistory';

export default WorkHistory;
